import React from 'react';
import { useStripe, useElements, CardNumberElement } from '@stripe/react-stripe-js';
import { Button, ButtonTextTransform, ButtonType } from 'swag-client-common/components/ui/button';
import { ConfirmCreditCardRemovingPopup } from '../confirm-card-removing-popup';
import classes from './card-control-panel.scss';
export const CreditCardControlPanel = ({
  isCardExist,
  isValid,
  addCard,
  showPopup,
  isStripeElementsValid
}) => {
  const stripe = useStripe();
  const elements = useElements();
  const onSaveCard = event => {
    event.preventDefault();
    if (!stripe || !elements) {
      return;
    }
    const card = elements.getElement(CardNumberElement);
    if (!card) {
      return;
    }
    addCard(stripe, card);
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: classes.wrapper
  }, /*#__PURE__*/React.createElement(Button, {
    type: ButtonType.defaultGrey,
    onClick: showPopup,
    disabled: !isCardExist,
    className: classes.button,
    textTransform: ButtonTextTransform.none
  }, "Remove Card"), /*#__PURE__*/React.createElement(Button, {
    type: ButtonType.primary,
    onClick: onSaveCard,
    disabled: isCardExist || !isValid || !isStripeElementsValid,
    className: classes.button,
    textTransform: ButtonTextTransform.none
  }, "Save Card")), /*#__PURE__*/React.createElement(ConfirmCreditCardRemovingPopup, null));
};